module.exports = __webpack_public_path__ + "img/icon_partner_new@2x.2e8d17e7.png";